/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Grid, Modal, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import styled from "styled-components";
import CustomerDetail from "../../components/customer/CustomerDetail";
import BreadCrum from "../../components/layout/BreadCrumb";
import AccessibleLocker from "../../components/visitLogs/AccessibleLocker";
import LockerAccessHistory from "../../components/visitLogs/LockerAccessHistory";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { endpoints } from "../../api/endpoints";
import { useCrudForm } from "../../api/useCrudForm";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { Check, Close, Delete, Print, Reply, Verified } from "@mui/icons-material";
import { Delete as DeleteForever } from "@mui/icons-material";
import { cancelStyle } from "../../components/modal/cancelModalStyle";
import { toast } from "react-toastify";
import { AppContext } from "../../contexts/AppContext";
import moment from "moment";
import { LoadingButton } from "@mui/lab";
import CustomerDetailsPrint from "../../components/print/CustomerDetailsPrint";
import TableImage from "../../components/table/TableImage";
import CustomerInfoText, { TextLoading } from "../../components/customer/customerInfoText";
import { Container } from "../../components/styledComponent/Common";
import { TableHeadCell } from "../../components/styledComponent/table/TableCell";
import CustomerRejectForm from "./form/CustomerRejectForm";
import AddEditModal from "../../components/modal/Modal";

const LayoutNewCustomerReg = styled(Box)`
    padding: 10px 0;
`;

const CustomerDetails = () => {
    const [customerDetails, setCustomerDetails] = useState<any | null>();
    const [lockerAccessHistory, setLockerAccessHistory] = useState<Array<any>>([]);
    const [isApproved, setIsApproved] = useState<boolean>(false);
    const [isReject, setIsReject] = useState<boolean>(false);
    const [count, setCount] = useState<any>(0);
    const [skip, setSkip] = useState<any>(0);
    const [take, setTake] = useState<any>(10);
    const [loading, setLoading] = useState<boolean>(false);
    const [customerLoading, setCustomerLoading] = useState<boolean>(true);
    const { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isMainTable = queryParams.get('isMainTable');
    const [open, setOpen] = useState(false);
    const [openRequest, setOpenRequest] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openDeactivate, setOpenDeactivate] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [openPrint, setOpenPrint] = useState(false);
    const navigate = useNavigate();

    const { get, add, edit, deleteData } = useCrudForm();
    const { user } = useContext(AppContext)

    const mapCustomerLockes = (data: any, lockers: any) => {
        const unVerifiedLockers = lockers.length <= 0 ? data?.customerLockers : lockers
        if (unVerifiedLockers) {
            return unVerifiedLockers.map((loc: any) => {
                const matchingLocker = data?.customerLockers.find((locker: any) => locker.lockerId === loc.lockerId);
                if (matchingLocker) {
                    loc.isSameLockerStatus = loc.lockerstatus === matchingLocker.lockerstatus;
                    loc.tempLockerstatus = loc.lockerstatus
                    loc.lockerstatus = matchingLocker.lockerstatus
                } else {
                    loc.isSameLockerStatus = false;
                    loc.isNewLockers = true
                }
                return loc;
            });
        } else {
            return []
        }
    }

    const mapNomineeInformation = (data: any, nomineeInformation: any) => {
        const unVerifiedNomineeInformation = nomineeInformation;
        if (unVerifiedNomineeInformation) {
            return unVerifiedNomineeInformation.map((loc: any) => {
                const locId = loc.nomineeInfoId ?? loc.id
                const matchingNomineeInformation = data?.nomineeInformation.find((x: any) => x.id === locId);
                if (matchingNomineeInformation) {
                    loc.fullName = `${matchingNomineeInformation.firstName} ${matchingNomineeInformation.middleName ?? ''} ${matchingNomineeInformation.lastName}`
                    loc.tempfullName = `${loc?.firstName} ${loc.middleName ?? ''} ${loc?.lastName}`
                    loc.isSamefullName = loc.fullName === loc.tempfullName ? true : false

                    loc.isSameaddress = loc.address === matchingNomineeInformation.address;
                    loc.tempaddress = loc.address
                    loc.address = matchingNomineeInformation.address

                    loc.isSamenomineeRelationshipName = loc.nomineeRelationshipName === matchingNomineeInformation.nomineeRelationshipName;
                    loc.tempnomineeRelationshipName = loc.nomineeRelationshipName
                    loc.nomineeRelationshipName = matchingNomineeInformation.nomineeRelationshipName

                    loc.isSamecitizenshipNumber = loc.citizenshipNumber === matchingNomineeInformation.citizenshipNumber;
                    loc.tempcitizenshipNumber = loc.citizenshipNumber
                    loc.citizenshipNumber = matchingNomineeInformation.citizenshipNumber

                    loc.isSamemobileNumber = loc.mobileNumber === matchingNomineeInformation.mobileNumber;
                    loc.tempmobileNumber = loc.mobileNumber
                    loc.mobileNumber = matchingNomineeInformation.mobileNumber

                    loc.isSameemail = loc.email === matchingNomineeInformation.email;
                    loc.tempemail = loc.email
                    loc.email = matchingNomineeInformation.email

                    loc.isSameisActive = loc.isActive === matchingNomineeInformation.isActive;
                    loc.tempisActive = loc.isActive
                    loc.isActive = matchingNomineeInformation.isActive

                    loc.isSamephotoUrl = loc.photoUrl === matchingNomineeInformation.photoUrl;
                    loc.tempphotoUrl = loc.photoUrl
                    loc.photoUrl = matchingNomineeInformation.photoUrl

                    loc.isNewNomineeInformation = false
                } else {
                    loc.isSamefullName = false;
                    loc.isSameaddress = false;
                    loc.isSamenomineeRelationshipName = false;
                    loc.isSamecitizenshipNumber = false;
                    loc.isSamemobileNumber = false;
                    loc.isSameemail = false;
                    loc.isSameisActive = false;
                    loc.isSamephotoUrl = false;
                    loc.isNewNomineeInformation = true
                    loc.tempfullName = `${loc.firstName} ${loc.middleName} ${loc.lastName}`;
                    loc.tempaddress = loc.address
                    loc.tempnomineeRelationshipName = loc.nomineeRelationshipName
                    loc.tempcitizenshipNumber = loc.citizenshipNumber
                    loc.tempmobileNumber = loc.mobileNumber
                    loc.tempemail = loc.email
                    loc.tempisActive = loc.isActive
                    loc.tempphotoUrl = loc.photoUrl
                }
                return loc;
            });
        } else {
            return []
        }
    }

    const handlePrint = () => {
        setOpenPrint(true);
    }

    useEffect(() => {
        if (id) {
            setCustomerLoading(true)
            get({
                endpoints: `${endpoints.customer.api}/${id}?isMainTable=${isMainTable}`,
                onSuccess: (data: any) => {
                    const customerInfo = data.data.customerInfo ?? data.data.tempcustomerInfo

                    const customerLockers = mapCustomerLockes(data.data.customerInfo, data.data.tempcustomerInfo?.customerLockers ?? data.data.customerInfo?.customerLockers)
                    const nomineeInformation = mapNomineeInformation(data.data.customerInfo, data.data.tempcustomerInfo?.nomineeInformation ?? data.data.customerInfo?.nomineeInformation)

                    const mapCustomerInfo: any = Object.keys(customerInfo).reduce((acc: any, key: any) => {
                        return Object.assign(
                            acc,
                            { customerLockers: customerLockers },
                            { nomineeInformation: nomineeInformation },
                            {
                                [key]: customerInfo[key] !== '' ? customerInfo[key] : null, ['temp' + key]: data.data.tempcustomerInfo !== null ? data.data.tempcustomerInfo[key] !== '' ? data.data.tempcustomerInfo[key] : null : undefined,
                                ['isSame' + key]: data.data.tempcustomerInfo == null || data.data.customerInfo == null ? true : customerInfo[key] === data.data.tempcustomerInfo[key]
                            }
                        )
                    }, {})
                    setIsApproved(mapCustomerInfo?.tempisApproved !== undefined ? mapCustomerInfo?.tempisApproved : mapCustomerInfo?.isApproved !== undefined ? mapCustomerInfo?.isApproved : false)
                    setIsReject(mapCustomerInfo?.tempisReject !== undefined ? mapCustomerInfo?.tempisReject : mapCustomerInfo?.isReject !== undefined ? mapCustomerInfo?.isReject : false)
                    setCustomerDetails(mapCustomerInfo)
                    setCustomerLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    navigate('/customers')
                    setCustomerLoading(false)
                }
            })
        }
    }, [id, isReject])

    useEffect(() => {
        if (id) {
            get({
                endpoints: `${endpoints.lockerAccessHistory.api}?customerId=${id}&skip=${skip * take}&take=${take}`,
                onSuccess: (data: any) => {
                    setLockerAccessHistory(data?.data?.list)
                    setCount(data.data.count)
                    setLoading(false)
                },
                onError: (error: any) => {
                    setLoading(false)
                }
            })
        }

    }, [skip, take]);

    const handleClose = () => {
        setOpen(false);
        setOpenRequest(false);
        setOpenDelete(false);
        setOpenDeactivate(false);
        setOpenPrint(false);
    };

    const handleApproveCustomer = () => {
        if (id) {
            setCustomerLoading(true)
            edit({
                endpoints: endpoints.customer.verify(parseInt(customerDetails?.tempid ?? id)),
                onSuccess: (data: any) => {
                    toast.success(data?.message ?? 'Successfully Approved', { style: { background: '#3150A1' } })
                    navigate('/customers')
                    setCustomerLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    setCustomerLoading(false)
                    handleClose()
                },
                values: {}
            })
        }
    }

    const handleDelete = () => {
        if (id) {
            setCustomerLoading(true)
            deleteData({
                endpoints: `${endpoints.customer.delete}${id}`,
                onSuccess: (data: any) => {
                    toast.success(data?.message ?? 'Successfully Approved', { style: { background: '#3150A1' } })
                    navigate('/customers')
                    setCustomerLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    setCustomerLoading(false)
                    setOpenDelete(false)
                },
            })
        }
    }

    const handleDeactivate = () => {
        if (id) {
            setCustomerLoading(true)
            add({
                endpoints: `${endpoints.customer.deactivateJointPoa}${id}`,
                onSuccess: (data: any) => {
                    toast.success(data?.message ?? 'Successfully Approved', { style: { background: '#3150A1' } })
                    navigate('/customers')
                    setCustomerLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    setCustomerLoading(false)
                    setOpenDeactivate(false)
                },
                values: {}
            })
        }
    }

    const handleSendToApproval = () => {
        if (id) {
            setCustomerLoading(true)
            edit({
                endpoints: endpoints.customer.rejectToApproval(parseInt(customerDetails?.tempid ?? id)),
                onSuccess: (data: any) => {
                    toast.success(data?.message ?? 'Successfully Send to Approval', { style: { background: '#3150A1' } })
                    setIsApproved(false)
                    navigate('/customers')
                    setCustomerLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    setCustomerLoading(false)
                },
                values: {}
            })
        }
    }

    return (
        <Box>
            <TopBreadcrumbs />
            <div>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                    <Typography variant="h5" component="h2" mt={3} fontWeight={600}>Customer Details
                        {
                            user && (user?.role)?.toLowerCase() === 'maker' ?
                                <span>
                                    <Tooltip title="Edit Customer">
                                        <BorderColorIcon sx={{ width: '24px', height: '24px', marginLeft: "32px" }} onClick={() => {
                                            navigate({
                                                pathname: `/customers/new-registration/${id}`,
                                                search: `?isMainTable=${isMainTable}`
                                            })
                                        }} />
                                    </Tooltip>
                                </span>
                                : null
                        }
                    </Typography>
                    {
                        !customerLoading ? <Box>
                            {
                                user && (user?.role)?.toLowerCase() !== 'checker' && customerDetails?.accountType !== 0 && customerDetails?.isApproved === true && customerDetails?.isActive === true && isMainTable === 'true' ? <Button onClick={() => setOpenDeactivate(true)} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#FF0000', '&:hover': { backgroundColor: '#FF0000', } }}>
                                    <Delete />
                                    <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Deactivate</Typography>
                                </Button> : null
                            }
                            {
                                customerDetails?.accountType !== 0 && customerDetails?.isActive === false ? <Button variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#FF0000', marginLeft: '16px', '&:hover': { backgroundColor: '#FF0000', } }}>
                                    <Delete />
                                    <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Deactivated</Typography>
                                </Button> : null
                            }
                            <Button onClick={handlePrint} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                                <Print />
                                <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Print</Typography>
                            </Button>
                            {
                                isApproved === true ? <Button variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#07bc0c', marginLeft: '16px', '&:hover': { backgroundColor: '#07bc0c', } }}>
                                    <Verified />
                                    <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Verified</Typography>
                                </Button> : (user?.role)?.toLowerCase() === 'admin' || (user?.role)?.toLowerCase() === 'checker' ?
                                    isReject === true && isMainTable === 'false' ? <>
                                        <Button onClick={() => setOpenRequest(true)} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                                            <Reply />
                                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Approval Request</Typography>
                                        </Button>
                                        <Button onClick={() => setOpenDelete(true)} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#FF0000', marginLeft: '16px', '&:hover': { backgroundColor: '#FF0000', } }}>
                                            <DeleteForever />
                                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Delete</Typography>
                                        </Button>
                                    </> : <>
                                        <Button onClick={() => setOpen(true)} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                                            <Check />
                                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Verify</Typography>
                                        </Button>
                                        <Button onClick={() => {
                                            setOpenReject(true)
                                        }} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#FF0000', marginLeft: '16px', '&:hover': { backgroundColor: '#FF0000', } }}>
                                            <Close />
                                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Reject</Typography>
                                        </Button>
                                    </>
                                    : null
                            }
                        </Box> : null
                    }
                </Stack>

                <Stack direction="row" justifyContent="right" gap={2} alignItems="center" mb={1}>
                    <Box sx={{ display: "flex", gap: "10px", justifyContent: 'center', alignItems: 'center' }}>
                        <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By:</Typography>
                                <small style={{ fontSize: "14px" }}>{customerDetails?.createdUsername ?? "N/A"}</small>
                            </Box>
                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created Date:</Typography>
                                <small style={{ fontSize: "14px" }}>{customerDetails?.createdDate ? moment(customerDetails?.createdDate).format('YYYY/M/D') : "N/A"}</small>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                        <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By:</Typography>
                                <small style={{ fontSize: "14px" }}>{customerDetails?.updatedUsername ?? "N/A"}</small>
                            </Box>
                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated Date:</Typography>
                                <small style={{ fontSize: "14px" }}>{customerDetails?.updatedDate ? moment(customerDetails?.updatedDate).format('YYYY/M/D') : "N/A"}</small>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                        <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By:</Typography>
                                <small style={{ fontSize: "14px" }}>{customerDetails?.verifiedUsername ?? "N/A"}</small>
                            </Box>
                            <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified Date:</Typography>
                                <small style={{ fontSize: "14px" }}>{customerDetails?.verifiedDate ? moment(customerDetails?.verifiedDate).format('YYYY/M/D') : "N/A"}</small>
                            </Box>
                        </Box>
                    </Box>
                </Stack>

                <LayoutNewCustomerReg>
                    <CustomerDetail isApproved={isApproved} customer={customerDetails} loading={customerLoading} />
                    {
                        customerDetails?.accountType !== 2 ? <NomineeDetails nomineeInformation={customerDetails?.nomineeInformation} loading={customerLoading} /> : null
                    }
                    <Grid container spacing={2}>
                        <Grid item xs={6} md={6}>
                            <AccessibleLocker customerId={customerDetails?.id} customerLocker={customerDetails?.customerLockers} setIsApproved={setIsApproved} />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <LockerAccessHistory lockerAccessHistory={lockerAccessHistory} loading={loading} count={count} setSkip={setSkip} setTake={setTake} take={take} skip={skip} />
                        </Grid>
                    </Grid>
                </LayoutNewCustomerReg>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to approve?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If cancel, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <LoadingButton loading={customerLoading} onClick={handleApproveCustomer} variant='contained' color='success'>Yes</LoadingButton>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
            <Modal
                open={openRequest}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to send to approval?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If cancel, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <LoadingButton loading={customerLoading} onClick={handleSendToApproval} variant='contained' color='success'>Yes</LoadingButton>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
            <Modal
                open={openDeactivate}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to deactivate?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If cancel, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <LoadingButton loading={customerLoading} onClick={handleDeactivate} variant='contained' color='success'>Yes</LoadingButton>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
            <Modal
                open={openDelete}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to delete?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If cancel, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <LoadingButton loading={customerLoading} onClick={handleDelete} variant='contained' color='success'>Yes</LoadingButton>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
            <Modal
                open={openPrint}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: "80%", height: "90%", overflowY: 'scroll' }} mt={8} textAlign={'left'}>
                    <CustomerDetailsPrint />
                </Box>
            </Modal>
            <AddEditModal title={`Account No. ${customerDetails?.accountNumber}`} setOpen={setOpenReject} open={openReject} setSelectedItem={() => { }} >
                <CustomerRejectForm selectedItem={customerDetails} setOpen={setOpenReject} setIsReject={setIsReject} />
            </AddEditModal>
        </Box >
    );
}

const TopBreadcrumbs = () => {
    const location = [{ name: "Customers", to: "/customers" }, { name: "Details" }]
    return (
        <BreadCrum location={location} />
    );
}

export default CustomerDetails;

export const NomineeDetails = ({ nomineeInformation, loading, isPrint = false }: any) => {
    return <>
        <Container sx={{ width: "100%", marginTop: `${isPrint ? "0px" : "10px"}`, paddingTop: '0 !important' }}>
            <Box sx={{ width: "100%" }}>
                <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                    Nominee Information
                </Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell minwidth='20%'>Full Name</TableHeadCell>
                                <TableHeadCell minwidth='20%'>Address</TableHeadCell>
                                <TableHeadCell minwidth='10%'>Relationship</TableHeadCell>
                                <TableHeadCell minwidth='10%'>Citizenship</TableHeadCell>
                                <TableHeadCell minwidth='10%'>Mobile</TableHeadCell>
                                <TableHeadCell minwidth='15%'>Email</TableHeadCell>
                                <TableHeadCell minwidth='5%' align='center'>Photo</TableHeadCell>
                                <TableHeadCell minwidth='10%' align='center'>Active</TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                nomineeInformation && nomineeInformation?.length > 0 ? nomineeInformation.map((row: any, index: number) => (
                                    <TableRow key={index}
                                        sx={{
                                            "&:last-child td, &:last-child th": {
                                                border: 0,
                                            },
                                        }}
                                    >
                                        {
                                            row?.isNewNomineeInformation ? <>
                                                <TableCell sx={{ padding: '0 0 0 5px', position: 'relative' }}>
                                                    <Typography sx={{ position: 'absolute', color: 'green', fontSize: '11px', top: '0px', right: '6px' }}>
                                                        Newly Added
                                                    </Typography>
                                                    <TextLoading loading={loading} value={row?.tempfullName} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <TextLoading loading={loading} value={row?.tempaddress} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <TextLoading loading={loading} value={row?.tempnomineeRelationshipName} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <TextLoading loading={loading} value={row?.tempcitizenshipNumber} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <TextLoading loading={loading} value={row?.tempmobileNumber} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <TextLoading loading={loading} value={row?.tempemail} />
                                                </TableCell>
                                                <TableCell sx={{ padding: 0, textAlign: 'center' }}><TableImage value={row.tempphotoUrl} /></TableCell>
                                                <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                                    <TextLoading loading={loading} value={row?.tempisActive ? 'YES' : 'NO'} />
                                                </TableCell>
                                            </> : <>
                                                <TableCell sx={{ padding: '0 0 0 5px' }}>
                                                    <CustomerInfoText loading={loading} isSame={!row?.isSamefullName} value={row?.fullName} tempValue={row?.tempfullName} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <CustomerInfoText loading={loading} isSame={!row?.isSameaddress} value={row?.address} tempValue={row?.tempaddress} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <CustomerInfoText loading={loading} isSame={!row?.isSamenomineeRelationshipName} value={row?.nomineeRelationshipName} tempValue={row?.tempnomineeRelationshipName} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <CustomerInfoText loading={loading} isSame={!row?.isSamecitizenshipNumber} value={row?.citizenshipNumber} tempValue={row?.tempcitizenshipNumber} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <CustomerInfoText loading={loading} isSame={!row?.isSamemobileNumber} value={row?.mobileNumber} tempValue={row?.tempmobileNumber} />
                                                </TableCell>
                                                <TableCell sx={{ padding: '0 10px' }}>
                                                    <CustomerInfoText loading={loading} isSame={!row?.isSameemail} value={row?.email} tempValue={row?.tempemail} />
                                                </TableCell>
                                                <TableCell sx={{ padding: 0, textAlign: 'center' }}><TableImage value={row?.tempphotoUrl ?? row?.photoUrl} /></TableCell>
                                                <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                                    <CustomerInfoText loading={loading} isSame={!row?.isSameisActive} value={row?.isActive ? 'YES' : 'NO'} tempValue={row?.tempisActive ? 'YES' : 'NO'} />
                                                </TableCell>
                                            </>
                                        }
                                    </TableRow>
                                )) : <TableRow>
                                    <TableCell colSpan={8} align="center">No Data Found</TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Container>
    </>
}